module.exports = __webpack_public_path__ + "02_mid_yellow.cf4e65d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/02_mid_yellow.png
// module id = aCMT
// module chunks = 0